// @flow
import styled from 'styled-components';

export const SectionContent = styled.div`
  padding: 16px;
  overflow-x: auto;
`;

export const WarningCellElement = styled.div`
  color: red;
  background: #ffa39e;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
`;
